import { render, staticRenderFns } from "./providerDetailsModal.vue?vue&type=template&id=0474b42f&scoped=true"
import script from "./providerDetailsModal.vue?vue&type=script&lang=js"
export * from "./providerDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./providerDetailsModal.vue?vue&type=style&index=0&id=0474b42f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474b42f",
  null
  
)

export default component.exports